import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      colors: [
        'cove-green',
        'cove-forest-green',
        'cove-blue',
        'cove-navy-blue',
        'cove-dove',
        'cove-baby-dove',
        'cove-dark-grey',
        'cove-red',
        'cove-white',
      ],
      spacing: [2, 5, 10, 15, 25, 35, 50, 75, 87, 100, 137, 150, 290, 320].map(
        num => `cove-${num}`
      ),
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
